import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Interaction, ReportData } from "../common/types";
import { metricStyle, metricKeys } from "../common/labels";
import { formatShortDate } from "../common/helpers/utils";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const getLabels = (reportData: ReportData) => {
  const labels = reportData.interactions.map((i) => {
    return formatShortDate(i.timestamp);
  });
  return labels;
};
const getDataset = (reportData: ReportData) => {
  const datasets = metricKeys.map((key) => {
    return {
      label: metricStyle[key].label,
      data: reportData.interactions.map((i) => {
        return i[key as keyof Interaction];
      }),
      borderColor: metricStyle[key].color,
      backgroundColor: metricStyle[key].color_background,
      borderWidth: 1,
      tension: .25,
      pointRadius: 0,
    };
  });
  return datasets;
};
interface ReportChartProps {
  reportData: ReportData;
}
const options = {
  maintainAspectRatio: false,
  responsive: true,
  interaction: {
    mode: "index" as const,
    intersect: false,
  },
  stacked: false,
  plugins: {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
  },
  scales: {
    y: {
      type: "linear" as const,
      display: true,
      position: "left" as const,
      grid: {
        display: false,
      },
    }
  },
};
function ReportChart({ reportData }: ReportChartProps) {
  return (
    <Line
      options={options}
      data={{ datasets: getDataset(reportData), labels: getLabels(reportData) }}
    />
  );
}

export default ReportChart;
